import { render, staticRenderFns } from "./ModalStockOther.vue?vue&type=template&id=764acaab&scoped=true&"
import script from "./ModalStockOther.vue?vue&type=script&lang=js&"
export * from "./ModalStockOther.vue?vue&type=script&lang=js&"
import style0 from "./ModalStockOther.vue?vue&type=style&index=0&id=764acaab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764acaab",
  null
  
)

export default component.exports